import React from 'react';
import './Experience.css';

const experiences = [
    {
        role: "Full Stack Developer",
        company: "Eidverse FC",
        location: "Dubai (Remote)",
        period: "Jun 2024 – Present",
        type: "Full-time",
        highlights: [
            "Independently owned end-to-end full-stack development, delivering production features without additional engineering support.",
            "Designed and built AI-driven systems, including an automated LinkedIn profile evaluation pipeline using data scraping and LLM-based analysis.",
            "Built and maintained cloud infrastructure end-to-end using AWS (S3, CloudFront, API Gateway, Lambda, EC2, VPC, SES, Route 53).",
            "Designed and implemented an automated email system to support application workflows and user communication.",
            "Developed internal admin panels for reward distribution, engagement insights, and operational control.",
            "Integrated frontend applications with backend APIs and PostgreSQL databases.",
            "Contributed to product and technical decision-making, influencing feature scope, architecture, and delivery priorities."
        ],
        tags: ["Next.js", "React", "Node.js", "FastAPI", "PostgreSQL", "AWS", "LLM", "AI Automation"]
    },
    {
        role: "Frontend Developer (Independent)",
        company: "EVQLabs",
        location: "Dubai (Remote)",
        period: "Jul 2023 – Jun 2024",
        type: "Full-time",
        highlights: [
            "Worked independently on frontend development for multiple internal and client-facing products.",
            "Built responsive UI components and implemented dynamic functionality based on product requirements.",
            "Collaborated with designers and backend developers to ensure smooth feature delivery and consistent user experience.",
            "Deployed and maintained frontend applications using AWS S3 and CloudFront.",
            "Assisted with backend tasks during early project stages and supported outreach-related work, demonstrating adaptability across roles."
        ],
        tags: ["Next.js", "React", "JavaScript", "AWS S3", "CloudFront", "UI/UX"]
    },
    {
        role: "Junior Frontend Developer",
        company: "EVQLabs",
        location: "Dubai (Remote)",
        period: "Nov 2022 – Jul 2023",
        type: "Full-time",
        highlights: [
            "Built and maintained frontend features for production web applications.",
            "Implemented functional, responsive UI components from design mockups.",
            "Fixed UI bugs, improved usability, and optimized frontend performance.",
            "Gained hands-on experience collaborating in production environments and contributing to real-world products."
        ],
        tags: ["React", "JavaScript", "CSS", "Tailwind", "Responsive Design"]
    }
];

const Experience = () => {
    return (
        <section id="experience" className="experience-section mt-5 pt-4 pb-5">
            <div className="container">
                <div className="section-header mb-5 text-center">
                    <h2 className="title">Work Experience</h2>
                    <p className="subtitle text-light mt-3 mx-auto" style={{ maxWidth: '750px', lineHeight: '1.6' }}>
                        Over 2 years of professional experience building production-grade systems end-to-end — from AI-powered backends to cloud infrastructure and polished frontends.
                    </p>
                </div>

                <div className="experience-timeline">
                    {experiences.map((exp, index) => (
                        <div key={index} className="experience-item">
                            <div className="timeline-dot"></div>
                            <div className="experience-card">
                                <div className="experience-header">
                                    <div className="experience-meta">
                                        <h3 className="experience-role">{exp.role}</h3>
                                        <div className="experience-company">
                                            <span className="company-name">{exp.company}</span>
                                            <span className="company-divider">·</span>
                                            <span className="company-location">{exp.location}</span>
                                        </div>
                                    </div>
                                    <div className="experience-time">
                                        <span className="experience-period">{exp.period}</span>
                                        <span className="experience-type">{exp.type}</span>
                                    </div>
                                </div>

                                <ul className="experience-highlights">
                                    {exp.highlights.map((point, i) => (
                                        <li key={i} className="highlight-item">
                                            <span className="highlight-bullet"></span>
                                            <span>{point}</span>
                                        </li>
                                    ))}
                                </ul>

                                <div className="experience-tags">
                                    {exp.tags.map((tag, i) => (
                                        <span key={i} className="exp-tag">{tag}</span>
                                    ))}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Experience;
